'use client'

import { useMemo } from 'react'

import type { InstallationCardTabConfig, Technology } from '@graftcode/design-system'
import { InstallationCard } from '@graftcode/design-system'

import { GraftabilityWarningTabContent } from '@/core/components/GraftabilityWarningTabContent'
import type { LibraryData } from '@/core/types/library.type'
import type { LibraryGraftabilityReport } from '@/core/utils/graftability'

import type { InstallationTab } from '../../types'

import styles from './CardInstallation.module.scss'

interface CardInstallationProps {
  installationCardKey: string
  technologies: Technology[]
  suggestedTechnologies: string[]
  selectedTechnology?: string
  tabs: InstallationTab[]
  libraryData?: LibraryData
  graftabilityReport?: LibraryGraftabilityReport | null
  onTechnologyChange: (technology: string) => void
  onConnectionStringGenerator: () => void
}

export function CardInstallation({
  installationCardKey,
  technologies,
  suggestedTechnologies,
  selectedTechnology,
  tabs,
  libraryData,
  graftabilityReport,
  onTechnologyChange,
  onConnectionStringGenerator,
}: CardInstallationProps) {
  const installationCardTabs = useMemo((): InstallationCardTabConfig[] => {
    const codeTabs: InstallationCardTabConfig[] = tabs

    if (!graftabilityReport || graftabilityReport.graftable) {
      return codeTabs
    }

    return [
      {
        label: 'Warning',
        content: <GraftabilityWarningTabContent libraryData={libraryData} report={graftabilityReport} />,
      },
      ...codeTabs,
    ]
  }, [tabs, graftabilityReport, libraryData])

  return (
    <div className={styles.container}>
      <InstallationCard
        key={installationCardKey}
        technologies={technologies}
        suggestedTechnologies={suggestedTechnologies}
        selectedTechnology={selectedTechnology}
        tabs={installationCardTabs}
        onTechnologyChange={(technology) => onTechnologyChange(technology ?? '')}
        onConnectionStringGenerator={onConnectionStringGenerator}
      />
    </div>
  )
}
